/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

export const unit = 8;
export const colors = {
  primary: '#220a82',
  secondary: '#14cbc4',
  accent: '#e535ab',
  background: '#FFFFFF',
  grey: '#d8d9e0',
  text: '#3e3e3e',
  textSecondary: '#747790',
  shadow: '#00000029',
  accessory: '#057CB1',
  inputBorder: '#747474',
  icon: '#44B6E6',
  link: '#0267B8',
  footerText: '#CFCFCF',
  hoverLight: '#EAF4F8',
  hoverDark: '#014E71',
  disabledBackground: '#DBDBDB',
  disabledText: '#B4B1B1',
  loginInputBackground: '#F9F9F9',
  errorMessage: '#CF4234',
  successMessage: '#04871C'
};

export const fonts = {
  primary: "'Noto Sans', sans-serif"
};

export const globalStyles = {
  '@global': {
    [['html', 'body']]: { height: '100%' },
    body: {
      margin: 0,
      padding: 0,
      fontFamily: fonts.primary,
      backgroundColor: colors.background,
      color: colors.text
    },
    '#root': { display: 'flex', flexDirection: 'column', minHeight: '100%' },
    '*': { boxSizing: 'border-box' },
    [['h1', 'h2', 'h3', 'h4', 'h5', 'h6']]: { margin: 0, fontWeight: 600 },
    h1: { fontSize: 48, lineHeight: 1 },
    h2: { fontSize: 40 },
    h3: { fontSize: 32 },
    h5: { fontSize: 16, textTransform: 'uppercase', letterSpacing: 4 }
  }
};

export const dropzoneStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 1,
  borderRadius: 1,
  borderColor: '#949494',
  borderStyle: 'dashed',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};
